import { useCycleStore } from '@cycle-hangars/store/store';
import {
  CycleHangarsFeatureAttributes,
  CycleHangarsEstatesFeatureAttributes,
} from '@types';

export const SelectedLocationTextContent = () => {
  const { serviceLocationDetails, serviceAssetDetails } = useCycleStore();

  return (
    serviceLocationDetails.full_address && (
      <div className="text-bodyXl mt-4 flex flex-col gap-[1.25rem]">
        <p className="font-semibold text-black">{`Nearest address to cycle hangar`}</p>
        <p className="font-normal text-black">
          {serviceLocationDetails.full_address}
        </p>
        <p className="font-semibold text-black">{`Cycle hangar ID`}</p>
        <p className="font-normal text-black">
          {(serviceAssetDetails as CycleHangarsFeatureAttributes)?.CH_Ref ||
            (serviceAssetDetails as CycleHangarsEstatesFeatureAttributes)
              ?.Unit_ID ||
            'No cycle hangar selected'}
        </p>
      </div>
    )
  );
};
